__turbopack_context__.v({
  "header": "GlZWnG_header",
  "title": "GlZWnG_title",
});
